import React, { Fragment, useContext } from "react";
import Toolbar, { ToolbarGroup } from "components/Toolbar/Toolbar";
import ToolbarButton from "components/Toolbar/ToolbarButton";
import { TrashIcon, SupportIcon, PlusIcon } from "@heroicons/react/outline";
import { modal } from "components/HeadlessModal";
import { ChannelListContext } from "./ChannelScreen";
import { useAuth } from "hooks/Auth";
import { toast } from "react-hot-toast";
import { apiDel, messageFromException } from "helpers/Request";
import { useContextualHelp } from "hooks/Help";
import { useHistory } from "react-router-dom";
import DangerButton from "components/Buttons/DangerButton";
import SecondaryButton from "components/Buttons/SecondaryButton";

export default function ChannelListToolbar(props) {
    const auth = useAuth();
    const contextualHelp = useContextualHelp();
    const history = useHistory();

    const { selectedItems, load } = useContext(ChannelListContext);

    const onRequestDelete = () => {
        modal.warning({
            title: "Delete Channels",
            children: (
                <Fragment>
                    <div className="mb-4">
                        Deleting a channel will also remove all associated
                        entries.
                    </div>
                    <div>Are you sure you want to delete these channels?</div>
                </Fragment>
            ),
            buttons: () => (
                <Fragment>
                    <DangerButton onClick={handleDelete}>Delete</DangerButton>
                    <SecondaryButton onClick={modal.dismiss}>
                        Cancel
                    </SecondaryButton>
                </Fragment>
            ),
        });
    };

    const handleDelete = async () => {
        const id = toast.loading("Deleting channels...");
        const promises = selectedItems.map((uuid) =>
            apiDel(`/v4/channel/${uuid}`, auth.publication)
        );
        return Promise.all(promises)
            .then(() => {
                toast.success("Channels deleted", { id });
                modal.dismiss();
                load();
            })
            .catch((err) => {
                modal.dismiss();
                toast.dismiss(id);
                modal.error({
                    title: "Error Deleting Channels",
                    children: messageFromException(err),
                });
            });
    };

    return (
        <Toolbar>
            <ToolbarGroup>
                <ToolbarButton
                    icon={<PlusIcon />}
                    onClick={() =>
                        history.push("/app/custom-content/channel/new")
                    }
                >
                    Add
                </ToolbarButton>
                <ToolbarButton
                    icon={<TrashIcon />}
                    onClick={onRequestDelete}
                    disabled={!selectedItems.length}
                >
                    Delete
                </ToolbarButton>
            </ToolbarGroup>
            <ToolbarGroup className="ml-auto">
                <ToolbarButton
                    icon={<SupportIcon />}
                    className="text-green-600"
                    onClick={() =>
                        contextualHelp.showContextualHelp(
                            "/custom-content/index.html"
                        )
                    }
                >
                    Help
                </ToolbarButton>
            </ToolbarGroup>
        </Toolbar>
    );
}
